import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authStore/authSlice';
import { userManagementApi } from './services/userManagementService';
import { sellerApi } from './services/sellerService';
import { postManagementApi } from './services/postManagementService';
import { categoryManagementServiceApi } from './services/categoryManagementService';
import { authApi } from './services/authService';
import { supportApi } from './services/supportService';
import categoryReducer from './slices/category/categorySlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    category: categoryReducer,
    [userManagementApi.reducerPath]: userManagementApi.reducer,
    [postManagementApi.reducerPath]: postManagementApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [supportApi.reducerPath]: supportApi.reducer,
    [categoryManagementServiceApi.reducerPath]:
      categoryManagementServiceApi.reducer,
    [sellerApi.reducerPath]: sellerApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat([
      userManagementApi.middleware,
      postManagementApi.middleware,
      authApi.middleware,
      supportApi.middleware,
      categoryManagementServiceApi.middleware,
      sellerApi.middleware,
    ]),
  devTools: process.env.NODE_ENV !== 'production',
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
